{
  "CallsheetPublic": {
    "loadingTitle": "Loading callsheet",
    "notPublishedTitle": "Callsheet Not Published",
    "notPublishedSubtitle": "The callsheet is in a draft state. Notify the author that they need to publish their callsheet.",
    "poweredByAtellio": "Powered by Atellio",
    "metaDescription": "A callsheet put together by {{teamName}} at {{companyName}}",
    "builtWith": "Built with"
  },
  "PublicCallsheetView": {
    "callsheetFor": "Callsheet for",
    "confirmReceived": "Confirm Received",
    "confirmed": "Confirmed"
  },
  "CallsheetPdfButton": {
    "downloadAsPDF": "Download as PDF"
  },
  "CallsheetContacts": {
    "name": "Name",
    "fillFromResource": "Fill from a resource",
    "role": "Role",
    "removeContact": "Remove contact",
    "mainContacts": "Main contact",
    "addContact": "Add contact"
  },
  "CallsheetCallTime": {
    "toLabel": "To",
    "fromLabel": "From",
    "removeDate": "Remove range",
    "addDateRange": "Add date range",
    "yourCallTime": "Your call time",
    "generalCrewCallTime": "General crew call time"
  },
  "CallsheetOutline": {
    "title": "Outline",
    "placeholder": "Write an outline about the day"
  },
  "CallsheetSectionSchedule": {
    "schedule": "Schedule",
    "removeTime": "Remove time",
    "addTime": "Add time",
    "title": "Title",
    "description": "Description",
    "removeLocation": "Remove location",
    "addSchedule": "Add schedule"
  },
  "CallsheetSectionLocation": {
    "header": "Location",
    "removeLocation": "Remove location",
    "addLocation": "Add location",
    "weather": "Weather",
    "weatherUnavailable": "Weather will appear here when published",
    "high": "High",
    "low": "Low"
  },
  "CallsheetTeamMembers": {
    "addResource": "Add resource",
    "newGroup": "New group"
  },
  "CallsheetAddResources": {
    "title": "Add resources",
    "group": "Group: {{name}}",
    "pick": "Pick for the callsheet",
    "onCallsheet": "On the callsheet",
    "noResults": "No resources found",
    "add": "Add to callsheet",
    "added_one": "Added {{count}} person to the callsheet",
    "added_other": "Added {{count}} people to the callsheet",
    "addFailed": "Couldn’t add everyone to the callsheet. Try again."
  },
  "CallsheetTeamItem": {
    "actions": "Team member actions",
    "role": "Role",
    "note": "Note",
    "purchaseOrder": "PO Number",
    "email": "Email",
    "phone": "Phone",
    "callTime": "Call time",
    "addEmail": "Add email",
    "addPhoneNumber": "Add phone number",
    "removePersonalCallTime": "Remove personal call time",
    "showPersonalCallTime": "Show personal call time",
    "removeContactDetails": "Remove contact details",
    "showContactDetails": "Show contact details",
    "addPersonalNote": "Add personal note",
    "editPersonalNote": "Edit personal note",
    "removeTeamMember": "Remove team member"
  },
  "CallsheetTeamGroup": {
    "addSlot": "Add slot",
    "addGroup": "Add group"
  },
  "CallsheetTeamGroupHeader": {
    "groupName": "Group name",
    "removeGroup": "Remove group",
    "areYouSure": "Are you sure?",
    "removeGroupWarning": "This will remove all slots associated with this group",
    "delete": "Delete",
    "groupNotEmpty": "This group is not empty",
    "groupNotEmptyDesc": "You cannot delete a group if there are roles and expenses within it. Either move these into another group or delete them to continue."
  },
  "CallsheetTeamSectionHeader": {
    "areYouSure": "Are you sure?",
    "removeSectionWarning": "This will remove all slots associated with this production",
    "delete": "Delete"
  },
  "CallsheetDocument": {
    "displayError": "Could not display callsheet",
    "billing": "Billing",
    "social": "Social",
    "hardDrive": "Hard Drive"
  },
  "CallsheetSectionNotes": {
    "title": "Additional notes",
    "placeholder": "Write additional notes…"
  },
  "CallsheetLocationMap": {
    "directions": "Directions open in new window",
    "map": "Map",
    "mapOf": "Map of {{destination}}"
  },
  "CallsheetPdf": {
    "address": "Address",
    "purchaseOrderFor": "Purchase Order Number For {{displayName}}: {{purchaseOrder}}",
    "billing": "Billing",
    "social": "Social",
    "hardDrive": "Hard Drive",
    "outline": "Outline",
    "descriptionHere": "Description here",
    "personalNote": "Personal note to {{displayName}}",
    "poNumber": "PO Number:",
    "callTime": "Call time",
    "for": "for",
    "from": "From",
    "to": "To",
    "mainContacts": "Main contact",
    "mainContactsPlural": "Main contacts",
    "location": "Location",
    "schedule": "Schedule",
    "additionalNotes": "Additional Notes",
    "attachments": "Attachments",
    "fileURL": "File URL",
    "weather": "Weather",
    "high": "High",
    "low": "Low",
    "note": "Note"
  },
  "TransferCallsheetDialog": {
    "title": "Transfer to workspace",
    "description_one": "Move {{name}} to another workspace and team.",
    "description_other": "Move {{count}} callsheets to another workspace and team.",
    "fieldWorkspace": "Destination workspace",
    "fieldTeam": "Destination team",
    "success_one": "Callsheet transferred",
    "success_other": "{{count}} callsheets transferred"
  },
  "CallsheetActions": {
    "transfer": "Transfer to workspace"
  },
  "ChooseCallsheetTeam": {
    "title": "New callsheet",
    "description": "Callsheets belong to a team. Choose the team the new callsheet is created in."
  }
}
